<template>
  <div class="text-bold d-flex align-items-center">
    <b-button :class="linksColor" :to="prevPageLink" variant="link" class="px-0">
      <div class="d-flex justify-content-center align-items-center">
        <b-icon-arrow-left-short font-scale="2" class="mr-1" />
        <p class="mb-0">{{ prevPage }}</p>
      </div>
    </b-button>
    <span v-if="currentPage" class="ml-2">/ {{ currentPage }}</span>
  </div>
</template>

<script>
export default {
  name: "BackButton",
  props: {
    currentPage: String,
    prevPage: String,
    prevPageLink: String | Object,
    linkColor: String,
  },
  computed: {
    linksColor: function () {
      return "text-" + this.linkColor;
    },
  },
};
</script>

<style scoped lang="scss">
p {
  overflow: hidden;
}
svg {
  font-size: 3rem;
  margin: (-$spacer / 1.25) (-$spacer / 2);
}
</style>
